import { STORE_FORM_VALUES, ERROR_FORM_GETAPI, CLEAR_ERROR_FORM_GETAPI,
  ERROR_FORM_MESSAGE, CLEAR_ERROR_FORM_MESSAGE, CLEAR_FORM_VALUES
} from '../constants/Constants';

export const formReducer = (state : any = [], action : any) => {
    switch (action.type) {
      case CLEAR_ERROR_FORM_GETAPI: {
        let existingObject = state["formGetApiError"];
        if (existingObject === undefined) {
          return state;
        } else {
          let newState = {...state};
          newState["formGetApiError"] = false;
          return newState;
        }
      }
      case ERROR_FORM_GETAPI: {
        let existingObject = state["formGetApiError"];
        if (existingObject === undefined) {

          return {...state, formGetApiError : action.payload };
        } else {

          let newState = {...state};
          newState["formGetApiError"] = action.payload;
          return newState;
        }
      }
      case ERROR_FORM_MESSAGE: {
          let existingObject = state[action.payload.formName + "_ERROR"];
          if (existingObject === undefined) {
  
            return {...state, [action.payload.formName + "_ERROR"] : action.payload.errorMessage };
          } else {
  
            let newState = {...state};
            newState[action.payload.formName + "_ERROR"] = action.payload.errorMessage;
            return newState;
          }
      }
      case CLEAR_ERROR_FORM_MESSAGE: {
        let existingObject = state[action.payload.formName + "_ERROR"];
          if (existingObject === undefined) {
  
            return {...state, [action.payload.formName + "_ERROR"] : "" };
          } else {
  
            let newState = {...state};
            newState[action.payload.formName + "_ERROR"] = "";
            return newState;
          }
      }

      case STORE_FORM_VALUES:
      {
        let existingObject = state[action.payload.formName];
        if (existingObject === undefined) {

          return {...state, [action.payload.formName] : action.payload.values };
        } else {

          let newState = {...state};
          newState[action.payload.formName] = action.payload.values;
          return newState;
        }
      }
      case CLEAR_FORM_VALUES:
      {
        let existingObject = state[action.payload.formName];
        if (existingObject !== undefined) {
          let newState = {...state};
          newState[action.payload.formName] = {};
          return newState;
        } else {
          return state;
        }
      }
      default:
        return state;
    }
};